export enum ContractSustainabilityPriceEnum {
  FIRM = 'Ferme',
  REVIEWABLE = 'Révisable',
}
